// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import Column from "./column"
import _content from "../../../content/layouts/footer.json"

const AboutUsColumn = ({ langKey }) => {
  const {
    AboutSeelk,
    WhoAreWe,
    Careers,
    Blog,
    Legal,
    CookiesPolicy,
  } = _content[langKey]

  const content = [
    {
      paragraph: WhoAreWe,
      url: langKey === `en` ? `/about-seelk/` : `/${langKey}/about-seelk/`,
    },
    { paragraph: Careers, url: "undefined" },
    {
      paragraph: Blog,
      url: langKey === `en` ? `/blog` : `/${langKey}/blog`,
    },
    {
      paragraph: Legal,
      url: langKey === `en` ? `/legal-notice/` : `/${langKey}/legal-notice/`,
    },
    {
      paragraph: CookiesPolicy,
      url: langKey === `en` ? `/cookies-policy` : `/${langKey}/cookies-policy`,
    },
  ]

  const url = langKey === `en` ? `/about-seelk/` : `/${langKey}/about-seelk/`
  return <Column title={AboutSeelk} content={content} url={url} />
}

export default AboutUsColumn
